import React, { useContext } from "react";

import { useUserProvider } from "../context/UserProvider";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import { ColorModeContext } from "../context/ColorModeProvider";
import { Container, Toolbar, AppBar, Typography, Box } from "@mui/material";

// import MenuIcon from "@mui/icons-material/Menu";

import AdbIcon from "@mui/icons-material/Adb";
import logo from "../images/logo_full_hard_dark2.svg";
import logoLight from "../images/logo_full_hard_light.svg";

import AvatarMenu from "./AvatarMenu";
import ThemeSwitcher from "./ThemeSwitcher";
import { Link } from "react-router-dom";

const Navbar = () => {
  const { theme, colorMode } = useContext(ColorModeContext);
  const trigger = useScrollTrigger();
  const { user } = useUserProvider();

  return (
    <AppBar
      elevation={trigger ? 0.5 : 0}
      style={{
        position: "sticky",
        top: "0px",
        transition: "top 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        zIndex: "1100",
        backdropFilter: "blur(20px)",
        backgroundColor:
          theme.palette.mode === "dark"
            ? "rgba(10, 25, 41, 0.72)"
            : "rgba(255, 255, 255, 0.72)",
      }}
    >
      <Container>
        <Toolbar disableGutters>
          <Box sx={{ display: { xs: "flex" }, height: "40px", mr: 1 }}>
            <Link to="/">
              <img
                width="40px"
                src={theme.palette.mode === "dark" ? logo : logoLight}
              />
            </Link>
          </Box>
          {/* <Typography
            variant="h6"
            noWrap
            className="acoustic_logo_font"
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "flex" },

              color: theme.palette.mode === "dark" ? "#0159b2" : "#121828",
              textDecoration: "none",
            }}
          >
            Acoustic
          </Typography> */}

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}></Box>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "flex" } }}></Box>
          <Box mr={1.5} sx={{ flexGrow: 0 }}>
            <ThemeSwitcher />
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            {user ? <AvatarMenu {...user} /> : <AvatarMenu />}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Navbar;
